import { type ReactElement } from 'react'

import { useTranslate } from '@orus.eu/pharaoh'
import { LoadingRegion } from '@orus.eu/pharaoh-next/components/ui/loading-region'
import { Section } from '@orus.eu/pharaoh-next/components/ui/section'
import { Skeleton } from '@orus.eu/pharaoh-next/components/ui/skeleton'
import { View } from '@orus.eu/pharaoh-next/components/ui/view'

export function AttestationsPageSkeleton(): ReactElement {
  const translate = useTranslate()

  return (
    <LoadingRegion label={translate('loading_aria_label')}>
      <View.Root>
        <View.Header>
          <Skeleton variant="text" width={220} height={32} />
        </View.Header>

        <View.Body>
          <Section.Root>
            <Section.Header>
              <Section.Title.Skeleton width={120} />
              <Section.Actions>
                <Skeleton variant="button" width={110} height={32} className="max-md:hidden" />
                <Skeleton variant="button" width={32} height={32} className="md:hidden" />
              </Section.Actions>
            </Section.Header>
            <Section.Body>
              <Skeleton variant="block" height={144} />
            </Section.Body>
          </Section.Root>

          <Section.Root>
            <Section.Header>
              <Section.Title.Skeleton width={200} />
              <Section.Actions>
                <Skeleton variant="button" width={110} height={32} className="max-md:hidden" />
                <Skeleton variant="button" width={32} height={32} className="md:hidden" />
              </Section.Actions>
            </Section.Header>
            <Section.Body>
              <Skeleton variant="block" height={144} />
            </Section.Body>
          </Section.Root>
        </View.Body>
      </View.Root>
    </LoadingRegion>
  )
}
